import * as React from "react";
const NewsSearch = (props) => (
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.16699 0.208313C3.67968 0.208313 0.0419922 3.846 0.0419922 8.33331C0.0419922 12.8206 3.67968 16.4583 8.16699 16.4583C12.6543 16.4583 16.292 12.8206 16.292 8.33331C16.292 3.846 12.6543 0.208313 8.16699 0.208313ZM1.29199 8.33331C1.29199 4.53636 4.37004 1.45831 8.16699 1.45831C11.964 1.45831 15.042 4.53636 15.042 8.33331C15.042 12.1303 11.964 15.2083 8.16699 15.2083C4.37004 15.2083 1.29199 12.1303 1.29199 8.33331Z"
      fill="#CED5E5"
    />
    <path
      d="M15.2757 14.5581C15.0316 14.314 14.6359 14.314 14.3918 14.5581C14.1477 14.8022 14.1477 15.1979 14.3918 15.442L17.725 18.7753C17.9691 19.0194 18.3648 19.0194 18.6089 18.7753C18.853 18.5312 18.853 18.1355 18.6089 17.8914L15.2757 14.5581Z"
      fill="#CED5E5"
    />
  </svg>
);
export default NewsSearch;
